import { MAX_SCRIVENER_ZIP_BYTES } from "../../../../../src/shared/constants";

const formatMaxSize = () => {
  const mb = MAX_SCRIVENER_ZIP_BYTES / (1024 * 1024);
  return `${mb} MB`;
};

export const determineScrivenerToastMessage = (error) => {
  switch (error) {
    case "Invalid Scrivener backup":
      return "This doesn't appear to be a valid Scrivener backup. Please ensure you're uploading a .zip file created using Scrivener's 'Back Up To...' feature with 'Back up as ZIP file' checked.";
    case "No .scrivx file found":
      return "Could not find a Scrivener project file (.scrivx) in this backup. Please ensure this is a valid Scrivener backup.";
    case "Too many requests":
      return "You can only import one project at a time. Please wait for the current import to complete before starting a new one.";
    case "Scrivener ZIP too large":
      return `Your Scrivener backup is too large (max ${formatMaxSize()}). Try reducing its size by removing media files before exporting.`;
    default:
      return "Could not import your Scrivener project. Please try again.";
  }
};
